import React from 'react'
import { Button, Tooltip } from '@mui/material'

export default function InputButton({
  children,
  href,
  startIcon,
  endIcon,
  onClick,
  width,
  title = '',
  fullWidth = true,
  size = 'medium',
  variant = 'contained',
  sx = null,
  color = 'primary',
  ...props
}) {
  const Root = href ? 'a' : 'button'

  return (
    <Tooltip title={title}>
      <Button
        fullWidth={fullWidth}
        component={Root}
        href={href}
        variant={variant}
        size={size}
        startIcon={startIcon}
        endIcon={endIcon}
        color={color}
        onClick={onClick}
        sx={[
          sx,
          {
            textTransform: 'none',
            fontWeight: 'bold',
            width: width ? width : 'none',
          },
        ]}
        {...props}
      >
        {children}
      </Button>
    </Tooltip>
  )
}
